/**
 * Inbox Triage Lesson
 * Skill Area: Operations
 * Batch similar requests with efficient templates
 */

import type { LessonDefinition } from '../types';
import { INBOX_TRIAGE_AI_PROMPT, INBOX_TRIAGE_CONTEXT_SCENARIOS } from '../prompts/inbox-triage.prompt';

export const inboxTriage: LessonDefinition = {
  id: 'inbox-triage',
  title: 'Inbox Triage',
  displayTitle: 'Batch Similar Requests with Efficient Templates',
  subTitle: 'Group asks and reply with one note.',
  tagline: "Bundle similar requests and answer with care.",
  persona: 'Lyra',
  skillArea: 'Operations',
  format: 'tool_lab',
  difficulty: 'Beginner',
  estimatedMinutes: 6,
  tags: ['ops', 'templates', 'execution'],
  dailyEligible: true,
  releasedAt: '2025-02-05T00:00:00.000Z',
  route: '/micro/ai-inbox-triage',
  storyBeat: 'Lyra keeps your replies steady and kind.',
  contextTitle: "Great clusters to start with",
  contextSummary: "Think about the threads that repeat every week. These examples work well with Lyra.",
  contextScenarios: INBOX_TRIAGE_CONTEXT_SCENARIOS,
  introPrompt: "A chaotic inbox drains your energy. I'll explain why batching works, show you a comparison, and help you draft one reply for many requests.",
  steps: [
    "Identify emails asking the same question",
    'See a "Treadmill vs. Batch" comparison',
    'Draft one kind, clear reply for the whole group'
  ],
  promptGuidance: 'Choose a request below or type your own.',
  aiPrompt: INBOX_TRIAGE_AI_PROMPT,
  inputPlaceholder: "Type 'Program FAQs' or your own request...",
  quickPrompts: [
    'Program FAQs',
    'Audit Questions',
    'Volunteer Scheduling'
  ]
};
